export enum ButtonState {
    Hidden = "Hidden",
    Disabled = "Disabled",
    Enabled = "Enabled",
    Working = "Working"
  }

  

/**
 * Returns a css class for this enabled state
 */
export function getCssClassFromButtonState(buttonState: ButtonState) {
    switch (buttonState){
      case ButtonState.Hidden:
        return 'invisible';
      case ButtonState.Disabled:
        return 'disabled but-still-clickable';
      case ButtonState.Enabled:
        return '';
      case ButtonState.Working:
        return 'disabled working';
    }
  }